export default {
  iframePopupSrc(state) {
    return state.iframe_src;
  },
  iframePopupTitle(state) {
    return state.iframe_title;
  },
  iframePopupVisible(state) {
    return state.iframe_visible;
  },
  videoPopupSrc(state) {
    return state.video_src;
  },
  videoPopupTitle(state) {
    return state.video_title;
  },
  videoPopupCaptions(state) {
    return state.video_captions;
  },
  videoPopupTranscript(state) {
    return state.video_transcript;
  },
  videoPopupVisible(state) {
    return state.video_visible;
  },
  helpPopupVisible(state) {
    return state.help_popup_visible;
  },
  getFocusElemOnPopupClose(state) {
    return state.focusElemOnPopupClose;
  },
};
